<template>
  <NuxtLink class="Card" :to="'/pokemon/single/' + data.inventory_product_id">
    <PMCardImage
      :alt="data.product_name"
      loading="lazy"
      :url="data.pm_card.card_image1_url"
      :view-transition-name="disableViewTransition ? undefined : `thumbnail-${data.inventory_product_id}`"
    />
    <div>
      <div class="productName">{{ data.product_name }}</div>
      <div class="info">{{ cardInfoString }}</div>
    </div>
    <div class="lowestPrice" v-if="availableInventories.length">{{ lowestAvailablePrice.toLocaleString() }}<span class="unit">円〜</span> </div>
    <div class="stockOut" v-else>在庫切れ</div>
  </NuxtLink>
</template>

<script lang="ts">
import { defineNuxtComponent } from "#app";
import { computed } from "vue";
import { PMCardImage } from '@ka-nabellinc/ka-nabell-ui'
import type { ESPokemonSingleProduct } from "@ka-nabellinc/tcg-platform-es-schema";

export default defineNuxtComponent({
  components: {
    PMCardImage
  },
  props: {
    data: {
      type: Object as () => ESPokemonSingleProduct,
      required: true,
    },
    disableViewTransition: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const allInventories = computed(() => [
      props.data.rank_s_inventory,
      props.data.rank_a_inventory,
      props.data.rank_b_inventory,
      props.data.rank_c_inventory,
    ]);

    const cardInfoString = computed(() => {
      let infoString = "";

      if (props.data.pm_card.pack.expansion_mark) {
        infoString += `[${props.data.pm_card.pack.expansion_mark}]`;
      }

      infoString += `[${props.data.pm_card.rarity.rarity_abbreviation}]`;

      return infoString;
    });
    const availableInventories = computed(() => allInventories.value.filter(i => i.inventory_num > 0))
    const lowestAvailablePrice = computed(() => {
      if (!availableInventories.value.length) {
        return 0
      } else {
        return availableInventories.value.sort((a, b) => a.selling_price - b.selling_price)[0].selling_price
      }
    })

    return {
      lowestAvailablePrice,
      availableInventories,
      cardInfoString
    }
  },
});
</script>

<style scoped>
.Summary {
  width: 100%;
}

.thumbnail {
  margin-bottom: 4px;
}

.productName {
  font-size: 13px;
  line-height: 150%;
  letter-spacing: 0.13px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.info {
  font-size: 10px;
  line-height: 160%;
  letter-spacing: 0.1px;
}

.lowestPrice {
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.32px;
  display: flex;
  align-items: flex-end;
}

.unit {
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.12px;
}

.stockOut {
  width: 100%;
  height: 24px;
  background: var(--semantic-colors-background-gray);
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.12px;
  color: var(--semantic-colors-text-gray);
  text-align: center;
}
</style>
